(() => {
  document.querySelectorAll('[data-treatment-menu]').forEach(menu => {
    if (menu.dataset.bound) return;
    menu.dataset.bound='true';
    const summary=menu.querySelector('summary');
    const pointer=matchMedia('(hover:hover) and (pointer:fine)');
    let timer;
    const close=()=>{clearTimeout(timer);menu.open=false;};
    menu.addEventListener('pointerenter',()=>{if(pointer.matches){clearTimeout(timer);timer=setTimeout(()=>{menu.open=true;},100);}});
    menu.addEventListener('pointerleave',()=>{if(pointer.matches){clearTimeout(timer);timer=setTimeout(()=>{if(!menu.contains(document.activeElement))close();},200);}});
    menu.addEventListener('toggle',()=>{clearTimeout(timer);if(menu.open)document.querySelectorAll('.lf-signup-menu[open],.lf-menu-item details[open]').forEach(other=>{other.open=false;});});
    menu.querySelector('[data-mega-close]')?.addEventListener('click',()=>{close();summary.focus();});
    menu.addEventListener('focusout',()=>{setTimeout(()=>{if(!menu.contains(document.activeElement))close();},0);});
    document.addEventListener('click',event=>{if(!menu.contains(event.target))close();});
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu.open){close();summary.focus();}});
    document.querySelectorAll('.lf-signup-menu').forEach(other=>other.addEventListener('toggle',()=>{if(other.open)close();}));
  });
})();

